import { BlogPost } from '../types';

// Function to parse frontmatter from markdown content
const parseFrontmatter = (content: string) => {
  const frontmatterRegex = /^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/;
  const match = content.match(frontmatterRegex);
  
  if (!match) {
    throw new Error('Invalid frontmatter format');
  }
  
  const [, frontmatterStr, markdownContent] = match;
  const frontmatter: any = {};
  
  // Parse YAML-like frontmatter
  frontmatterStr.split('\n').forEach(line => {
    const colonIndex = line.indexOf(':');
    if (colonIndex > 0) {
      const key = line.substring(0, colonIndex).trim();
      let value = line.substring(colonIndex + 1).trim();
      
      // Remove quotes if present
      if ((value.startsWith('"') && value.endsWith('"')) || 
          (value.startsWith("'") && value.endsWith("'"))) {
        value = value.slice(1, -1);
      }
      
      // Parse arrays
      if (value.startsWith('[') && value.endsWith(']')) {
        value = value.slice(1, -1).split(',').map(item => item.trim().replace(/['"]/g, ''));
      }
      
      // Parse numbers
      if (!isNaN(Number(value)) && value !== '') {
        value = Number(value);
      }
      
      frontmatter[key] = value;
    }
  });
  
  return {
    frontmatter,
    content: markdownContent
  };
};

// Function to load all blog posts
export const loadBlogPosts = async (): Promise<BlogPost[]> => {
  const blogPosts: BlogPost[] = [];
  
  // List of blog post files
  const blogPostFiles = [
    'stromstotte-ordning-2025.md',
    'redusere-stromforbruk-vinter.md',
    'varforhold-strompriser-norge.md',
    'prisomrader-strompriser-variasjon.md',
    'elbillading-smart-lading.md',
    'norgespris-strom-regjeringens-nye-stromtiltak.md',
    'norgespris-2027-bestille-pa-nytt.md',
    'norgespris-eller-stromstotte-2027.md',
    'stromstotte-2026-2027.md',
    'stromregningen-2026-avgifter-nettleie.md'
  ];
  
  // Load each blog post
  for (const fileName of blogPostFiles) {
    try {
      const response = await fetch(`/blog-posts/${fileName}`);
      if (!response.ok) continue;
      
      const content = await response.text();
      const { frontmatter, content: markdownContent } = parseFrontmatter(content);
      
      const blogPost: BlogPost = {
        id: frontmatter.slug,
        title: frontmatter.title,
        slug: frontmatter.slug,
        excerpt: frontmatter.excerpt,
        content: markdownContent,
        author: frontmatter.author,
        publishDate: frontmatter.publishDate,
        updatedDate: frontmatter.updatedDate,
        imageUrl: frontmatter.imageUrl,
        categories: Array.isArray(frontmatter.categories) ? frontmatter.categories : [frontmatter.categories],
        tags: Array.isArray(frontmatter.tags) ? frontmatter.tags : [frontmatter.tags],
        readTime: frontmatter.readTime
      };
      
      blogPosts.push(blogPost);
    } catch (error) {
      console.warn(`Failed to load blog post: ${fileName}`, error);
    }
  }
  
  // Sort by publish date (newest first)
  return blogPosts.sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());
};